import { render } from "./PInfoPublish.vue?vue&type=template&id=ed2b23aa&scoped=true"
import script from "./PInfoPublish.vue?vue&type=script&lang=js"
export * from "./PInfoPublish.vue?vue&type=script&lang=js"

import "./PInfoPublish.vue?vue&type=style&index=0&id=ed2b23aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2b23aa"]])

export default __exports__